import loc, { format } from 'owa-localize';
import {
    bookWithMeDurationMinutes,
    bookWithMeDurationOneHour,
    bookWithMeDurationHours,
    bookWithMeDurationOneHourAndMinutes,
    bookWithMeDurationHoursAndMinutes,
} from './Duration.locstring.json';

export default function getSimpleDurationString(duration: number): string {
    var hours = 0;
    if (duration < 60) {
        return format(loc(bookWithMeDurationMinutes), duration); // Display minutes if duration is less than an hour
    } else if (duration % 60 == 0) {
        hours = duration / 60;
        if (hours == 1) {
            return loc(bookWithMeDurationOneHour); // Display One hour duration string
        } else {
            return format(loc(bookWithMeDurationHours), duration / 60); // Display hours if the duration is a multiple of 60
        }
    } else {
        hours = Math.floor(duration / 60);
        if (hours == 1) {
            return format(loc(bookWithMeDurationOneHourAndMinutes), duration % 60); //Display One hour and Minutes string
        } else {
            return format(loc(bookWithMeDurationHoursAndMinutes), hours, duration % 60); // Otherwise display both
        }
    }
}
